import React from 'react';
import coursePageStyle from './style';
import Banner from '../banner/index';

export default function CourseLandingScreen({title, mt}) {
	let style = coursePageStyle();
	return (
		<div style={style.outerStyle({mt: mt})}>
			<div style={style.titleRowStyle()}>
				<h1 style={style.titleSyle()}>{title}</h1>
				<p style={style.thankYouText()}>Thank you for purchasing this workout</p>
			</div>
		</div>
	);
}
